import React from 'react';
import email from '../../components/email.json';

export default function OptoutAboveBoxFr() {
  return (
    <main>
      <p />
      <h1>{email.optout.landing.ui.body.section1.voltageTitle.fr}</h1>
      <h2>{email.optout.landing.ui.body.section1.header.fr}</h2>
      <hr />
      <h3>
        <strong>{email.optout.landing.ui.body.section1.subheader.fr}</strong>
      </h3>
      <p>
        {email.optout.landing.ui.body.section1.text1.fr}
        <em>{email.optout.landing.ui.body.section1.text1.italics.fr}</em>
      </p>
      <h3 className="whyKeep">{email.optout.landing.ui.body.section1b.subheader.fr}</h3>
      <p>
        {email.optout.landing.ui.body.section1b.text1.fr}
      </p>
      <p>
        {email.optout.landing.ui.body.section1b.text2.fr}
      </p>
    </main>
  );
}
